import * as React from 'react'
import DataGrid, { DataGridProps } from 'react-data-grid'
import { useRsi } from '../hooks/useRsi'

interface Props<Data> extends DataGridProps<Data> {
    // `rowHeight` vem do DataGridProps e aceita número ou função (altura por linha) — redeclará-lo
    // aqui como número impedia a linha expandida da Task #66347.
    hiddenHeader?: boolean
}

export const Table = <Data,>({ className, ...props }: Props<Data>) => {

    // function rowClass(row: Data) {
    //     return styles.row;
    // }

    
    const { rtl } = useRsi()
    return <DataGrid defaultColumnOptions={{ resizable: true }}  className={'rdg-light ' + className || ''} direction={rtl ? 'rtl' : 'ltr'} {...props} />
}
